const enumValue = description => Object.freeze({toString: () => description});

export const LABEL = enumValue('LABEL');
export const REQUESTED = enumValue('REQUESTED');
export const PROCESSED = enumValue('PROCESSED');
export const FOUND = enumValue('FOUND');
export const APPROVED = enumValue('APPROVED');
export const NO_SORT = enumValue('');
